// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.6 2.09C7.48 1.67 8.52 1.67 9.4 2.09L12.95 3.81C14.35 4.48 14.35 5.17 12.95 5.84L9.4 7.56C8.52 7.99 7.48 7.99 6.6 7.56L3.05 5.84C1.65 5.17 1.65 4.48 3.05 3.81Z',
  'M2 7.92C2 8.27 2.35 8.61 3.05 8.95L6.6 10.66C7.48 11.09 8.52 11.09 9.4 10.66L12.95 8.95C13.65 8.61 14 8.27 14 7.92',
  'M2 11.03C2 11.37 2.35 11.71 3.05 12.04L6.6 13.76C7.48 14.19 8.52 14.19 9.4 13.76L12.95 12.04C13.65 11.71 14 11.37 14 11.03',
];
